<template>
  <div class="vehicle-assignments" v-if="vehicle">

    <v-data-table
        :headers="headers"
        :items="items"
    >
      <template #item.type="{item}">
        {{ $t('vehicle.history-types.' + item.type) }}
      </template>

      <template #item.target="{item}">
        <template v-if="item.member">
          {{ item.member.name }}
        </template>
        <template v-else-if="item.customer">
          {{ item.customer.name }}
        </template>
        <template v-else-if="item.organization">
          {{ item.organization.name }}
        </template>
        <template v-else>-</template>
      </template>

      <template #item.performedBy="{item}">
        {{ item.performedBy ? item.performedBy.name : '-' }}
      </template>

      <template #item.performedAt="{item}">
        {{ item.performedAt ? formatDate(item.performedAt, $t('format_datetime')) : '-' }}
      </template>
    </v-data-table>

  </div>
</template>

<script>
import VehicleRepository from "@repository/VehicleRepository";

export default {
  data() {
    return {
      items: [],
    }
  },

  mounted() {
    this.loadData()
  },

  computed: {
    vehicle() {
      return this.$parent.vehicle ?? null
    },

    headers() {
      return [
        { text: this.$t('vehicle.assignment-type'), value: 'type', sortable: false },
        { text: this.$t('vehicle.organization') + ' / ' + this.$t('vehicle.customer'), value: 'target', sortable: false },
        { text: this.$t('vehicle.performed-by'), value: 'performedBy', sortable: false },
        { text: this.$t('vehicle.reason'), value: 'reason', sortable: false },
        { text: this.$t('date'), value: 'performedAt' },
      ]
    },
  },

  methods: {
    loadData() {
      if (!this.vehicle) return

      this.showLoading(true)
      VehicleRepository.assignmentHistory(this.vehicle.id, {}).then(response => {
        this.items = response.items || response
        this.showLoading(false)
      }).catch(err => {
        this.notifyError(err)
        this.showLoading(false)
      })
    },

  },
}
</script>

<style lang="scss">
</style>
